import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemCollectorsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-collectors',
	path: '/secure/admin/ViewGlobalCollectors([!%]?[\\w]*).jspa',
};
